import { useEffect } from 'react';

const THEME_KEY = 'leoclinic-theme';

type Theme = 'light' | 'dark';

/**
 * Hook para gestão de tema light/dark
 */
export function useTheme() {
  const getStoredTheme = (): Theme => {
    const stored = localStorage.getItem(THEME_KEY);
    if (stored === 'dark' || stored === 'light') return stored;
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  };

  const applyTheme = (theme: Theme) => {
    document.documentElement.classList.remove('light', 'dark');
    document.documentElement.classList.add(theme);
  };

  useEffect(() => {
    applyTheme(getStoredTheme());
  }, []);

  const toggleTheme = () => {
    const current = document.documentElement.classList.contains('dark') ? 'dark' : 'light';
    const next: Theme = current === 'dark' ? 'light' : 'dark';
    localStorage.setItem(THEME_KEY, next);
    applyTheme(next);
  };

  const theme: Theme = typeof document !== 'undefined' &&
    document.documentElement.classList.contains('dark')
    ? 'dark'
    : 'light';

  return { theme, toggleTheme };
}
